import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { ConsultaPrestamosService } from 'src/app/services/consulta-prestamos/consulta-prestamos.service';


export interface DialogData
{
    archivos: any
    idPostulacion: any
    montoSolicitado: any
    rutUsuario: any
    nombreUsuario: any
    apellidoUsuario: any    
    rol:any
    recarga:any
    cantidadCuota:any
    idCantidadCuota:any
    idCodeudor1:any
    idCodeudor2:any
    idPrestamo:any
    tipoPrestamo:any
    montoCuota:any
    fechaPrimerPago:any
    deshabilitado:true
    mostrarEditar: any

}

@Component({
    selector: 'dialog-overview-prestamo-dialog',
    templateUrl: '../../pages/prestamos/prestamos-validar.html',
    styleUrls: ['../../pages/prestamos/prestamos.component.css']
})
export class DialogEditPrestamo
{
    prestamo: any = {montoSolicitado:'',cantidadCuotas:'0',idCantidadCuota:'',
            idUsuario: '',idAfiliado:'',idCodeudor1:'',
      idCodeudor2:'',tipoPrestamo:'seleccione',
      nombreSolicitante:'', apellidoSolicitante:'', 
      idPostulacion:'',idPrestamo:'',montoCuota:0,
      archivos: []
    }
    cantidadArchivos: any = 2 
    constructor( public dialogRef: MatDialogRef<DialogEditPrestamo>,
        private consultaPrestamosService: ConsultaPrestamosService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog )
                 {
                    this.data.recarga = false
                    this.data= data;

                  }

    ngOnInit(): void
         { this.loadData() }
    loadData()
        {
            
            this.prestamo.idPostulacion = this.data.idPostulacion 
            this.prestamo.idPrestamo= this.data.idPrestamo
            this.data.recarga = false
            
            this.data.rol = localStorage.getItem('rol')
         

        }
    onCancelarClick(): void {  
    this.dialogRef.close()}

    onRechazarClick():void {
        let vm = this       
        const dialogRef = this.dialog.open(ConfirmationDialog,
            {
                data: { message: '¿Esta seguro de rechazar ser codeudor?', buttonText: { ok: 'Si', cancel: 'No' } }
            })
            dialogRef.afterClosed().subscribe((confirmed: boolean) =>
            {  
                if (confirmed){
                    Swal.fire({
                        allowOutsideClick:false,
                        icon:'info',
                        text:'Cargando...'
                      });
                      Swal.showLoading();
                    this.data.recarga = true 
                    this.consultaPrestamosService.rechazarSerCodeudor(this.prestamo,localStorage.getItem("idUsuario"),false).then
                    (
                        () =>
                        {
                            vm.openAlertDialog('Se ha rechazado ser codeudor.', 'btn-success')
                            this.data.recarga = true
                            Swal.close();
                        }
                    )
                    .catch((err) => {
                        vm.openAlertDialog('Ocurrió un al rechazar a ser codeudor.', 'btn-danger')
                    });
                      vm.dialogRef.close()
                     Swal.close();
                }
            })
        }
    
        
    onAceptarClick():void{
        let vm = this
        if(!this.prestamo.archivos[1]){
            this.openAlertDialog('Debe adjuntar el archivo de Cédula de Identidad (FRONTAL)', 'btn-dark')
            Swal.close();
            //this.procesando = false
            return;
        }
    
        if(!this.prestamo.archivos[2]){
            this.openAlertDialog('Debe adjuntar el archivo de Cédula de Identidad (POSTERIOR)', 'btn-dark')
            Swal.close();
            //this.procesando = false
            return;
        }
        const dialogRef = this.dialog.open(ConfirmationDialog,
        {
            data: { message: '¿Esta seguro de aceptar ser codeudor?', buttonText: { ok: 'Si', cancel: 'No' } }
        })
        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed){
                Swal.fire({
                    allowOutsideClick:false,
                    icon:'info',
                    text:'Cargando...'
                  });
                  Swal.showLoading();
            this.data.recarga = true
            let sizeArchivos = 0;
        
            for (let i = 1; i < this.cantidadArchivos; i++) {
                sizeArchivos += this.prestamo.archivos[i].size;
                if (sizeArchivos > 25000000) {
                    this.openAlertDialog('Los archivos no deben sobrepasar 25mb en total', 'btn-dark')
                    Swal.close();
                    //this.procesando = false
                    return;
                }
                if (this.prestamo.archivos[i].extension != "application/pdf" && this.prestamo.archivos[i].extension != "image/jpeg" &&
                    this.prestamo.archivos[i].extension != "image/jpg" && this.prestamo.archivos[i].extension != "image/png") {
                    this.openAlertDialog('El archivo ' + (i + 1) + ' debe ser de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
                    this.prestamo = false
                    Swal.close();
                    return false
                }
            }
          
            this.prestamo.idPrestamo = this.data.idPrestamo;
 

                  this.consultaPrestamosService.aprobarSerCodeudor(
                      this.prestamo,
                    localStorage.getItem("idUsuario"),true).then
                  (
                      () =>
                      {
                      
                          let vm=this
                          this.data.recarga = true
                          vm.openAlertDialog('Se ha aprobado ser codeudor exitosamente.', 'btn-success')
                          
                          Swal.close();
                      }
                  )
                  .catch((err) => {
                      vm.openAlertDialog('Ocurrió un error al aprobar ser codeudor.', 'btn-success')
                  });
                    vm.dialogRef.close()
                   Swal.close();
              }
                  vm.dialogRef.close()
                 Swal.close();
            }
         )
       
    }
   

    seleccionaArchivo(event: any, numero: number) {
        let vm = this
        if (event.target.files.length > 0) {
        
            let reader = new FileReader()

            reader.readAsDataURL(event.target.files[0])

            reader.onload = function () {
                vm.prestamo.archivos[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }

               
            }
        }
      
    }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
}
